export default __webpack_public_path__ + "static/191-1da9ef8e122fc072203a72c1b3788c00.jpg";